"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeTargeting = exports.updateTargeting = exports.getAdBlockerEventParams = exports.isAdsBlocked = exports.initializeClear = exports.getScripts = exports.getAssetsUrl = exports.checkExperimentsForAdsEligibility = void 0;
var PROD_UCI_ASSETS_URL = 'https://www.uciservice.com/assets/';
var INT_UCI_ASSETS_URL = 'https://www.uciservice.com/assets-int/';
var PROD_ENV_OPTIONS;
(function (PROD_ENV_OPTIONS) {
    PROD_ENV_OPTIONS["PRODUCTION"] = "production";
    PROD_ENV_OPTIONS["PROD"] = "prod";
})(PROD_ENV_OPTIONS || (PROD_ENV_OPTIONS = {}));
var envOptions = Object.values(PROD_ENV_OPTIONS);
function checkExperimentsForAdsEligibility(experiment) {
    if (!experiment) {
        return true;
    }
    var adsFeatureGate = experiment && experiment.exposures && experiment.exposures["meso_ads_feature_gate"];
    if ((adsFeatureGate === null || adsFeatureGate === void 0 ? void 0 : adsFeatureGate.bucket) === 1) {
        return false;
    }
    return true;
}
exports.checkExperimentsForAdsEligibility = checkExperimentsForAdsEligibility;
function getAssetsUrl() {
    return envOptions.includes(process.env.NODE_ENV.toLowerCase()) ?
        PROD_UCI_ASSETS_URL :
        INT_UCI_ASSETS_URL;
}
exports.getAssetsUrl = getAssetsUrl;
function getScripts() {
    var UCI_ASSETS_URL = getAssetsUrl();
    var scripts = [
        {
            src: UCI_ASSETS_URL + 'meso-loaders/bernie-loader.js',
            type: 'module',
        }
    ];
    return scripts;
}
exports.getScripts = getScripts;
function initializeClear() {
    // Clear the ADS cache.
    window.meso = window.meso || {};
    window.meso.initialize = window.meso.initialize || [];
    window.meso.initialize.push({ type: 'clear' });
}
exports.initializeClear = initializeClear;
function isAdsBlocked() {
    var _a, _b, _c;
    return (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.meso) === null || _a === void 0 ? void 0 : _a.adblock) === null || _b === void 0 ? void 0 : _b.enabled) !== null && _c !== void 0 ? _c : true;
}
exports.isAdsBlocked = isAdsBlocked;
function getAdBlockerEventParams() {
    var status = isAdsBlocked() ? 'enabled' : 'disabled';
    return {
        referrer: "adblocker." + status,
        linkName: "adblocker status: " + status,
    };
}
exports.getAdBlockerEventParams = getAdBlockerEventParams;
function updateTargeting(targetingData) {
    initializeTargeting();
    if (targetingData && window) {
        var targetingEvent = { type: 'update', targeting: targetingData };
        window.meso.targeting.push(targetingEvent);
    }
}
exports.updateTargeting = updateTargeting;
function initializeTargeting() {
    var _a, _b;
    if (window) {
        window.meso = (_a = window.meso) !== null && _a !== void 0 ? _a : {};
        window.meso.targeting = (_b = window.meso.targeting) !== null && _b !== void 0 ? _b : [];
    }
}
exports.initializeTargeting = initializeTargeting;
//# sourceMappingURL=index.js.map